export default (val)=>{
    if (!val.trim().match(/^\d{10}$/)) 
        return false;
    return true;
}